const middleware = {}

middleware['LoginPage'] = require('../../../middleware/LoginPage.ts')
middleware['LoginPage'] = middleware['LoginPage'].default || middleware['LoginPage']

middleware['portfolio'] = require('../../../middleware/portfolio.ts')
middleware['portfolio'] = middleware['portfolio'].default || middleware['portfolio']

middleware['redirectLanguage'] = require('../../../middleware/redirectLanguage.ts')
middleware['redirectLanguage'] = middleware['redirectLanguage'].default || middleware['redirectLanguage']

middleware['transactions'] = require('../../../middleware/transactions.ts')
middleware['transactions'] = middleware['transactions'].default || middleware['transactions']

middleware['walletAmount.resolver'] = require('../../../middleware/walletAmount.resolver.ts')
middleware['walletAmount.resolver'] = middleware['walletAmount.resolver'].default || middleware['walletAmount.resolver']

export default middleware
